import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function Opening() {
  const {
    t
  } = useLanguage();
  return <section className="pt-10 md:pt-14 pb-8 md:pb-12 bg-riam-jet relative overflow-hidden" data-id="element-197">
      {/* Decorative top border */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-riam-gold/30 to-transparent z-10" data-id="element-198"></div>
      <div className="gold-spotlight-top" aria-hidden="true" data-id="element-199" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-200">
        <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-201">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="font-script font-semibold text-3xl md:text-4xl text-riam-gold leading-relaxed" data-id="element-202">
            {t.opening.p1_1}
            <span className="font-allura font-normal text-4xl md:text-5xl align-middle mx-1" data-id="element-203">
              {t.opening.p1_highlight}
            </span>{' '}
            {t.opening.p1_2}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="font-sans font-normal text-lg text-riam-gold-light/90 leading-relaxed" data-id="element-204">
            {t.opening.p2_1}
            <em className="font-script font-semibold italic text-riam-gold text-[26px]" data-id="element-205">
              {t.opening.p2_highlight_1}
              <span className="font-allura font-normal not-italic text-4xl align-middle pr-1" data-id="element-206">
                {t.opening.p2_highlight_wow}
              </span>
              {t.opening.p2_highlight_2}
            </em>
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="font-sans text-lg text-riam-gold-light/90 leading-relaxed" data-id="element-207">
            {t.opening.p3}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="font-sans text-lg text-riam-gold-light/90 leading-relaxed" data-id="element-208">
            {t.opening.p4}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="font-script italic md:text-3xl text-riam-gold pt-4 text-[26px] font-[600]" data-id="element-209">
            {t.opening.p5}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="font-sans text-sm md:text-base text-riam-gold-light/90 leading-relaxed font-semibold tracking-[0.2em] uppercase mt-6" data-id="element-210">
            {t.opening.p6_1}
            <span className="gold-shine block mt-2" data-id="element-211">
              {t.opening.p6_highlight}
            </span>
          </motion.p>
        </div>
      </div>
    </section>;
}